module.exports = __webpack_public_path__ + "static/media/morty.5261fb4f.png";